// extracted by mini-css-extract-plugin
export var dark = "unified-search-results-module--dark--a3c7d";
export var grid = "unified-search-results-module--grid--d88e7";
export var list = "unified-search-results-module--list--5affd";
export var searchResults = "unified-search-results-module--searchResults--fc514";
export var title = "unified-search-results-module--title--53c43";
export var viewAllButton = "unified-search-results-module--viewAllButton--c3dff";
export var viewMoreButton = "unified-search-results-module--viewMoreButton--a8cc5";